import {requestJson} from './api.ts';
import {CharacterDefinition, CharacterDefinitionResponseSchema} from '@hexcrawl/shared-utils';

export async function fetchCharacterDefinition(characterId: string): Promise<CharacterDefinition> {
  const response = await requestJson<{definition: CharacterDefinition}>({
    url: `/character/definition?characterId=${encodeURIComponent(characterId)}`,
    schema: CharacterDefinitionResponseSchema,
  });
  return response.definition;
}
